<template>
  <div class="role-dialog">
    <el-dialog
      title="新增租户"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form :model="formData" :rules="rules" ref="tenant">
        <el-form-item
          class="management-id"
          label="租户名"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="formData.name"
            autocomplete="off"
            class="manage-id select"
            placeholder="请输入租户名称"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          class="management-id"
          label="租户类型"
          :label-width="formLabelWidth"
          prop="tenantType"
        >
          <el-select v-model="formData.tenantType" placeholder="请选择租户类型">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="menu-permissions">
            <div class="menu-permissions-left">
              <span class="menu-permissions-icon">*</span
              ><span>设置租户管理员菜单权限</span>
            </div>
            <div class="menu-permissions-right role">
              <div class="content_content">
                <div
                  class="menu-permissions-right-box"
                  v-for="(item, index) in checkboxList"
                  :key="index"
                >
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="parent"
                    @change="handleCheckAllChange(index, item)"
                    :label="item.id"
                    >{{ item.name }}</el-checkbox
                  >
                  <!-- <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" class="check-boxs" > -->
                  <!-- <el-checkbox v-model="parent" class="check-boxs" :label="item.id" @change="checkboxClick(item)">{{item.name}}</el-checkbox> -->
                  <el-checkbox-group v-model="parent">
                    <el-checkbox
                      v-for="citem in item.contentPermissionDTOs"
                      :key="citem.id"
                      :label="citem.id"
                      class="check-boxs-child"
                      @change="handleCheckedCitiesChange(item, citem)"
                      >{{ citem.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                  <!-- <el-checkbox v-model="parent" class="check-boxs" :label="item.id" >{{item.name}}</el-checkbox>
                <div v-for="(citem,indexs) in item.contentPermissionDTOs" :key="indexs" class="check-boxs-child">
                  <el-checkbox v-model="parent"  :label="citem.id">{{citem.name}}</el-checkbox>
                </div> -->
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { filter } from 'vue/types/umd';
export default {
  name: "newRoleDialog",
  props: ["dialogFormVisible", "checkboxList", "parentList", "formData"],
  watch: {
    "formData.name"(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.name = this.$utils.removalSpace(newValue);
      }
    },
    dialogFormVisible(newValue, oldValue) {
      if (!newValue) {
        this.$refs.tenant.resetFields();
      }
      this.dialogVisible = newValue;
    },
    parentList(newValue, oldValue) {
      //
      this.parent = newValue;
    },
  },
  data() {
    return {
      isIndeterminate: false,
      form: {
        name: "",
        type: "",
      },
      parent: [],
      options: [
        {
          value: 1,
          label: "内部租户",
        },
        {
          value: 2,
          label: "私域租户",
        },
        {
          value: 3,
          label: "非私域外部租户",
        },
      ],
      formLabelWidth: "120px",
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入租户名称", trigger: "blur" }],
        tenantType: [
          { required: true, message: "请输入租户类型", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.parent = this.parentList;
    //
  },
  methods: {
    handleCheckAllChange(i, data) {
      let flag = false;
      let arr = [];
      this.parent.map((item) => {
        if (item === data.id) {
          flag = true;
        }
      });
      data.contentPermissionDTOs.map((item) => {
        arr.push(item.id);
      });
      flag
        ? arr.map((item) => {
            this.parent.push(item);
          })
        : arr.map((item) => {
            this.parent.splice(
              this.parent.indexOf(item) === -1
                ? this.parent.length + 1
                : this.parent.indexOf(item),
              1
            );
          });
    },
    handleCheckedCitiesChange(val, item) {
      let flag = false;

      let arr = val.contentPermissionDTOs.map((item) => {
        return item.id;
      });
      this.parent.map((item) => {
        arr.map((item1) => {
          if (item === item1) {
            flag = true;
          }
        });
      });

      if (flag) {
        this.parent.map((item) => {
          if (this.parent.indexOf(val.id) === -1) {
            this.parent.push(val.id);
          }
        });
      } else {
        this.parent.map((item) => {
          if (this.parent.indexOf(val.id) !== -1) {
            this.parent.splice(this.parent.indexOf(val.id), 1);
          }
        });
      }
    },
    a() {},
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("changeDialog", false);
    },
    submit() {
      if (this.parent.length === 0) {
        return this.$message.error("请至少选择一种权限");
      } else {
        this.$refs.tenant.validate((valid) => {
          if (valid) {
            let data = {
              parentId: this.parent,
              listId: this.listId,
            };
            this.$emit("submit", data);
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-permissions-right {
  overflow-y: auto;
  overflow-x: hidden;
}
.dialog-footer {
  background-color: #fff;
  z-index: 999;
  padding: 10px;
}
.management-id {
  margin-top: 20px;
  // width: 34px;
}
.el-select {
  width: 276px;
}
.role-dialog {
  :deep(.el-dialog) {
    width: 722px;
    height: 502px;
    position: relative;
  }

  :deep(.el-dialog__header) {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;
  }

  :deep(.el-dialog__title) {
    font-size: 16px;
    color: #333840;
    font-weight: bolder;
  }
  .management-id {
    margin-left: 60px;
  }
  // .el-select__caret .el-input__icon .el-icon-arrow-up{
  //   line-height: 34px;
  // }
  :deep(.el-input.el-input--suffix) {
    height: 34px !important;
  }

  :deep(input.el-input__inner) {
    height: 34px;
  }
  // .el-input__inner{
  //   height:100%;
  // }
  .manage-id {
    width: 276px;
    height: 32px;
  }
  .menu-permissions {
    display: flex;
    &-left {
      padding-top: 26px;
    }
    &-right {
      .content_content {
        height: 190px;
        position: absolute;
        width: 440px;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 0;
        margin-top: 26px;
        left: 0;
        top: 0;
        right: -17px;
        bottom: 0;
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
        .check-boxs {
          margin-left: 10px;
        }
        .check-boxs-child {
          margin-top: -6px;
          margin-left: 30px;
        }
      }
      position: relative;
      // overflow: hidden;
      width: 420px;
      height: 212px;
      &-box {
        width: 100px;
        flex: 0 0 50%;
        height: 150px;
      }
    }
    &-icon {
      color: #f56c6c;
      margin-right: 2px;
      margin-left: 10px;
    }
  }
  :deep(.el-dialog__footer) {
    padding: 0;
    width: 100%;
    position: absolute;
    bottom: 29px;
    text-align: center;
  }

  :deep(.el-dialog__footer .el-button) {
    border-radius: 0;
    width: 70px;
    height: 34px;
    line-height: 10px;
  }

  :deep(.el-dialog__footer .el-button--primary) {
    background-color: dodgerblue;
    border-color: dodgerblue;
  }
}
.menu-permissions-right {
  margin-left: 10px;
}
.menu-permissions-right-box {
  height: auto !important;
}
.select {
  height: 32px;
}
.role-dialog :deep(.el-checkbox__inner) {
  z-index: 0;
}
.el-input__inner {
}
.role-dialog :deep(.el-dialog__headerbtn) {
  top: 10px !important;
}

.role-dialog :deep(.el-dialog__footer) {
  height: 20px !important;
}

.role-dialog :deep(.is-checked) {
  color: #000;
}
</style>
